import { Badge } from "@transfr-inc/dashboard-components";

import "./archived.badge.scss";

export const ArchivedBadge = () => {
  return <Badge className="archived-badge" value="ARCHIVED"></Badge>;
};
